import React from 'react'
import { useQuery } from '@apollo/client'
import styled from 'styled-components'
import Loader from '../../_common/loader'
import RelatedItem from './RelatedItem'
import { GET_RELATIONS } from 'setup/providerGQL'

const RelatedToTable = styled.table`
    max-width: 800px;
    border-collapse: collapse;
    th {
        padding: 10px 30px 10px 20px;
    }
    tr {
        border-top: 1px lightgrey solid;
	    //border-bottom: 1px lightgrey solid;
    }
    tr:last-child {
        border-bottom: 0;
    }
    td {
        padding: 10px 20px 10px 20px;
    }
`

export default function RelatedItems(props) {
    const { invMastUid } = props

    const { loading, data } = useQuery(GET_RELATIONS, {
        variables: { invMastUid }
    })

    const relatedToDisplay = data?.relatedTo?.map((r, i) => {
        return (
            <RelatedItem {...{
                ...r,
                key: i
            }} />
        )
    })

    return (
        <div>
            {!loading ? (
                <RelatedToTable>
                    <thead>
                        <tr>
                            <th>This item is a(n)...</th>
                            <th colSpan={2}>of the following product...</th>
                        </tr>
                     </thead>
                    <tbody>
                        {relatedToDisplay}
                    </tbody>
                </RelatedToTable>
            ) : <Loader />
            }
        </div>
    )
}
